import * as d3 from "d3";
import HeatMap from "../heatMap";
export default class HeatMapWidget {
    constructor(containerId, dotNetRef, heatMapData) {
        var _a, _b;
        console.log("HeatMapWidget constructor");
        HeatMapWidget.dotNetRef = dotNetRef;
        const heatMapSettings = heatMapData.settings;
        this._heatMap = new HeatMap(containerId, heatMapSettings.width, heatMapSettings.height, heatMapSettings.margins, heatMapSettings.rowNames, heatMapSettings.columnNames, d3.hsl(heatMapSettings.color0), d3.hsl(heatMapSettings.color1), (_a = heatMapSettings.hideRowLabels) !== null && _a !== void 0 ? _a : false, (_b = heatMapSettings.hideColumnLabels) !== null && _b !== void 0 ? _b : false);
        const squares = heatMapData.heatMapSquares;
        console.log(squares);
        this._heatMap.update(squares);
        this._heatMap.squareHover = (squareId) => {
            dotNetRef.invokeMethodAsync('OnJsHoverSquare', squareId);
        };
        this._heatMap.squareClick = (squareId) => {
            dotNetRef.invokeMethodAsync('OnJsClickSquare', squareId);
        };
        this._heatMap.xTickHover = (column) => {
            dotNetRef.invokeMethodAsync('OnJsHoverColumn', column);
        };
        this._heatMap.xTickClick = (column) => {
            dotNetRef.invokeMethodAsync('OnJsClickColumn', column);
        };
        this._heatMap.yTickHover = (row) => {
            dotNetRef.invokeMethodAsync('OnJsHoverRow', row);
        };
        this._heatMap.yTickClick = (row) => {
            dotNetRef.invokeMethodAsync('OnJsClickRow', row);
        };
        this._heatMap.unhover = (squareId) => {
            dotNetRef.invokeMethodAsync('OnJsUnhover', squareId);
        };
    }
}
